import { hydrateWidgets } from '@utils';
import { Atf } from '../../widgets/DVWebNodeDetail/widgets/Atf';
import { Btf } from '../../widgets/DVWebNodeDetail/widgets/Btf';
import { Additional } from '../../widgets/DVWebNodeDetail/widgets/Additional';

// At the moment hydrateWidgets will be executed after the HTML parsed
// therefore there is no point trying to hydrate ATF, BTF and Additional separately
// TODO: Change this once hydrateWidgets can support async loading
// https://i.amazon.com/issues/PVWeb-419
// Furthermore, by having them in the same file, the widgets can share the same store
hydrateWidgets(Atf);
hydrateWidgets(Btf);
hydrateWidgets(Additional);
